export default import.meta.ROLLDOWN_FILE_URL_EJeC7x5bQxYmCcrtlLPpUw